interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
      pages.push(i);
    }
  }

  return (
    <nav
      aria-label="分页导航"
      className="mt-10 flex flex-wrap items-center justify-center gap-2"
    >
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className="flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 text-xs text-foreground-700 transition-colors duration-200 hover:border-accent-400 hover:text-accent-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((value, index) => {
        const prev = pages[index - 1];
        const showEllipsis = prev !== undefined && value - prev > 1;
        return (
          <span key={value} className="flex items-center gap-2">
            {showEllipsis ? <span className="px-1 text-xs text-foreground-400">…</span> : null}
            <button
              type="button"
              onClick={() => onChange(value)}
              aria-current={value === page ? "page" : undefined}
              className={`h-9 w-9 cursor-pointer rounded-md font-label text-xs transition-colors duration-200 ${
                value === page
                  ? "bg-primary-900 text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-700 hover:border-accent-400 hover:text-accent-700"
              }`}
            >
              {value}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 text-xs text-foreground-700 transition-colors duration-200 hover:border-accent-400 hover:text-accent-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}